import React from 'react'
import PageTitle from '../../UI/PageTitle'
import PlanLoader from './PlanLoader'
import { useTranslation } from 'react-i18next'

const Plan = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle title={t('myPlan')} />
      <PlanLoader />
    </>
  )
}

export default Plan
